import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userAccessToken: null, 
  user: {
    id: null,
  },
  isAuthenticated: false,
  justRegistered: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setToken: (state, action) => {
      state.userAccessToken = action.payload.userAccessToken;
      state.user.id = action.payload.user_id;
      state.isAuthenticated = true;
    },

    clearToken: (state) => {
      state.userAccessToken = null;
      state.user.id = null;
      state.isAuthenticated = false;
    },
  },
});

export const { setToken, clearToken, setCountryId } = authSlice.actions;
export default authSlice.reducer;
